import React from 'react';
import { ITimelineEventStatusTag } from './claim-timeline.types';
import { statusTagToneColors } from './claim-timeline.styles';
import * as S from './claim-timeline.styles';

interface ITimelineStatusTagProps extends ITimelineEventStatusTag {
    dot?: boolean;
}

export const TimelineStatusTag = React.memo<ITimelineStatusTagProps>(({ tone, label, dot = true }) => {
    const styles = statusTagToneColors(tone);

    return (
        <S.StatusTag $bg={styles.bg} $fg={styles.fg}>
            {dot && <S.StatusTagDot $color={styles.dot} />}
            {label}
        </S.StatusTag>
    );
});
